import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'

export const containerStyle = css`
  padding: 0 var(--container-spacing);
  width: 100%;
  max-width: 170rem;
  margin: 0 auto;
`

export const Container = styled.div`
  ${containerStyle}

  ${mq.smallOnly} {
    display: flex;
    flex-direction: column;
  }
`

export const TextContainer = styled.div`
  ${containerStyle}
  max-width: 97rem;

  ${mq.large} {
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }
`

export const ArticleContent = styled.div`
  font-size: 1.6rem;

  ${mq.medium} {
    font-size: 2rem;
  }

  ${mq.large} {
    font-size: 2.4rem;
  }

  * {
    line-height: 1.4;
  }

  h2 {
    font-size: 2.5rem;
    font-weight: 800;

    ${mq.medium} {
      font-size: 3.5rem;
    }

    ${mq.large} {
      font-size: 4.1rem;
    }
  }
`
